// Воронка /start по шагам (28.10.2026): GA 21–27.10 — 254 человека открыли
// /start, сессий 5, и не видно, на каком шаге уходят. Здесь — имена шагов,
// причины отказа «Далее» и коды ошибок создания сессии. События шлёт
// trackStartStep (src/lib/analytics). В параметрах — только язык, пакет,
// ok/причина и код ошибки: ни почты, ни имени, ни токена.
//
// Без серверных импортов: модуль читают /start, экран оплаты и
// scripts/verify-start-funnel.mts.

export const START_STEPS = [
  "start_view",
  "start_lang",
  "start_age",
  "start_name",
  "start_email",
  "start_consent",
  "start_next_click",
  "start_error",
  "payment_view",
] as const;
export type StartStep = (typeof START_STEPS)[number];

/** Почта на blur: то же простое правило, что у браузерного type=email, без пробелов. */
export const looksLikeEmail = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

export type MissingField = "lang" | "age" | "name" | "email" | "consent";

/** Чего не хватает при «Далее» — в порядке формы. Пусто — можно дальше. */
export function missingFields(f: { language: string; ageGroup: string; nameOk: boolean; email: string; consent: boolean }): MissingField[] {
  const out: MissingField[] = [];
  if (!f.language) out.push("lang");
  if (!f.ageGroup) out.push("age");
  if (!f.nameOk) out.push("name");
  if (!looksLikeEmail(f.email)) out.push("email");
  if (!f.consent) out.push("consent");
  return out;
}

export type StartErrorCode = "rate_limited" | "captcha" | "age_unavailable" | "network" | "server";

/**
 * Код ошибки создания сессии для GA. Текст ошибки наружу не уходит: в нём
 * может оказаться что угодно (сообщение базы, ввод человека) — только код.
 */
export function startErrorCode(err: unknown): StartErrorCode {
  const m = err instanceof Error ? err.message : String(err ?? "");
  if (m.includes("rate_limited")) return "rate_limited";
  if (/captcha/i.test(m)) return "captcha";
  if (m.includes("Age group not available")) return "age_unavailable";
  if (err instanceof TypeError || /Failed to fetch|NetworkError|Load failed|network/i.test(m)) return "network";
  return "server";
}

/** Ключ «один раз за визит»: «Далее» и ошибка — по исходу, остальное — по шагу. */
export function stepKey(step: StartStep, p: { ok?: boolean; code?: string }): string {
  if (step === "start_next_click") return `${step}:${p.ok ? "ok" : "fail"}`;
  if (step === "start_error") return `${step}:${p.code ?? ""}`;
  return step;
}
